import actionCreator from '../../../utils/actionCreator';

const notificationActionTypes = [
  'GET_NOTIFICATIONS',
];

export const { types: notificationTypes, actions: notificationActions } = actionCreator(notificationActionTypes);
